import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'
import http from '../../../../../common/utils/http'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
  data () {
    return {
      searchInput: '',
      pageNum: 1,
      pageSize: 10,
      centerHeight: document.documentElement.clientHeight - 120 + 'px',
      type: '1000',
      activeIndex: '1000',
      options1: []
    }
  },
  computed: {
    ...mapState('pointsMailModule', ['pointsMailList']),
    pointsMailListInfo () {
      return this.pointsMailList
    }
  },
  methods: {
    ...mapActions('pointsMailModule', ['getCommodityPageList']),
    goTovoucherCollectionCenter () {
      Toast('功能暂未开放');
    },
    goToShopptingCard () {
      this.$router.push({
        path: RoutePathConstants.SHOPPTING_CART
      })
    },
    goToMemberCenter () {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_CENTER
      })
    },
    goToNewHomw () {
      this.$router.push({
        path: RoutePathConstants.NEW_HOUME_PAGE
      })
    },
    goToPageMailService () {
      this.$router.push({
        path: RoutePathConstants.PAGE_MAIL_SERVICE
      })
    },
    openProductById (id) {
      this.openCommodityDetails({ id: id })
    },
    openCommodityDetails (item) {
      this.$router.push({
        path: RoutePathConstants.PRODUCT_DETAILS,
        query: {
          id: item.id
        }
      })
    },
    openCommoditySearch () {
      this.$router.push({
        path: RoutePathConstants.PRODUCT_SEARCH,
        query: {
        }
      })
    },
    handleSelect (key, keyPath) {
      this.type = key
      this.getCommodityPageListInfo()
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    getCommodityPageListInfo () {
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.type !== '1000') {
        pageData.commodityType = this.type * 1
      }
      this.getCommodityPageList(pageData)
    },
    load () {
      this.pageSize += 10
      this.getCommodityPageListInfo()
    },
    goToClass () {
      this.$router.push({
        path: RoutePathConstants.COMMODITY_LIST,
      })
    },
    goToDetails (channel) {
      this.$router.push({
        path: RoutePathConstants.COMMODITY_CLASS,
        query: {
          channel: channel
        }
      })
    },
  },
  mounted () {
    if (this.$route.query.searchInput) {
      this.searchInput = this.$route.query.searchInput
    }
    // this.getCommodityPageListInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/views/points-mail-home-page.js